<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            v-model="shabuEVoucher.show"
            @hidden="$emit('clearShabuEVoucher')" 
            hide-footer
        >
        <template slot="modal-title">
            <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
                <div class="col-12">
                <h3 class="mb-0">ชาบูบู๊ตึ๊ง E-Voucher</h3>
                </div>
            </div>
            </div>
        </template>
        <card shadow type="secondary" class="m--4">
            <template v-if="switchModal === 'select'">
                <form @submit.prevent>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="group-result">
                                <div class="price">
                                    <div class="col-lg-3">
                                        <h6>E-Voucher</h6>
                                    </div>
                                    <div class="col-lg-9">
                                        <v-select
                                            class="w-100"
                                            placeholder="เลือก E-Voucher ที่ต้องการซื้อ"
                                            label="name"
                                            :options="shabu"
                                            v-model="shabuEVoucher.shabu"
                                            @input="selectShabuEVoucher"
                                        ></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="px-lg-5 py-lg-5 text-center">
                                <template v-if="shabuEVoucher.shabu !== null && shabuCondition.status == true && shabuCondition.confirm == true">
                                    <h4>กรุณาสแกน QR CODE ด้วย สมาร์ทโฟน</h4>
                                    <img class="image-hover py-2" :src="shabuEVoucher.shabu.qrCode" alt="qrcode" width="250" height="250">
                                    <div class="pt-2">
                                        หรือ
                                        <div class="pt-2">
                                            <a class="btn btn-info" :href="shabuEVoucher.shabu.link" target="_blank">
                                                เปิดบนเว็บเบราว์เซอร์
                                            </a>
                                        </div>
                                        <div class="pt-lg-4">
                                            <a class="a-tag color-tag px-1" @click="shabuOrderProcess.show = true">
                                                ขั้นตอนการสั่งซื้อ
                                            </a>
                                            <a :href="linkManual" target="_blank" class="px-1">
                                                อ่านคู่มือการใช้งาน E-Voucher ชาบูบู๊ตึ๊ง
                                            </a>
                                            <!-- <a :href="linkPolicy" target="_blank">
                                                รายละเอียดแต่ละกรมธรรม์
                                            </a> -->
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <h3 class="text-muted py-lg-5">กรุณาเลือก E-Voucher</h3>
                                    <div class="pt-lg-4">
                                        <a class="a-tag color-tag px-1" @click="shabuOrderProcess.show = true">
                                            ขั้นตอนการสั่งซื้อ
                                        </a>
                                        <a :href="linkManual" target="_blank" class="px-1">
                                            อ่านคู่มือการใช้งาน E-Voucher ชาบูบู๊ตึ๊ง
                                        </a>
                                        <!-- <a :href="linkPolicy" target="_blank">
                                            รายละเอียดแต่ละกรมธรรม์
                                        </a> -->
                                    </div>
                                </template>
                            </div>
                        </div>
                        <hr class="my-4" />
                    </div>
                    <div class="mt-4 w-100 text-right">
                        <b-button variant="secondary" @click="$emit('clearShabuEVoucher')">ปิด</b-button>
                        <b-button type="submit" variant="success" :disabled="!shabuEVoucher.shabu" @click="switchModal = 'pay'">ยืนยัน</b-button>
                    </div>
                </form>
            </template>
            <template v-else>
                <form @submit.prevent>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="group-result">
                                <div class="price">
                                    <div class="col-lg-5 text-left">
                                        <h6>E-Voucher</h6>
                                    </div>
                                    <div class="col-lg-7">
                                        <v-select
                                            class="'w-100'"
                                            placeholder="เลือก E-Voucher ที่ต้องการซื้อ"
                                            label="name"
                                            :options="shabu"
                                            v-model="shabuEVoucher.shabu"
                                            disabled="disabled"
                                        ></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="group-result">
                                <div class="price">
                                    <div class="col-lg-5 text-left">
                                        <h6>รหัส E-Voucher</h6>
                                    </div>
                                    <div class="col-lg-7">
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="กรุณากรอก E-Voucher Code"
                                            v-model="shabuEVoucher.code"
                                        />
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4" />
                            <div class="group-result">
                                <div class="price">
                                    <div class="col-lg-5 text-left">
                                        <h6>จำนวนเงิน</h6>
                                    </div>
                                    <div class="col-lg-7 text-right">
                                        <h1>
                                            {{( Number(shabuEVoucher.shabu.rate) ) | numFormat('0,0.00')}}
                                            <small>บาท</small>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4" />
                            <div class="group-result">
                                <div class="price">
                                    <div class="col-lg-5 text-left">
                                         <h6>ยอดสุทธิ</h6>
                                    </div>
                                    <div class="col-lg-7 text-right">
                                        <h1>
                                            {{( Number(shabuEVoucher.shabu.rate) ) | numFormat('0,0.00')}}
                                            <small>บาท</small>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4" />
                        </div>
                    </div>
                    <div class="mt-4 w-100 text-right">
                        <b-button variant="secondary" @click="$emit('clearShabuEVoucher')">ยกเลิก</b-button>
                        <b-button type="submit" variant="success" :disabled="!shabuEVoucher.code" @click="$emit('addShabuEVoucher')">ยืนยัน</b-button>
                    </div>
                </form>
            </template>
        </card>
        </b-modal>
        <ModalConditionShabu 
            :shabuCondition="shabuCondition" 
            @confirmConditionShabu="confirmConditionShabu()"
        />
        <ModalOrderProcessShabu
            :shabuOrderProcess="shabuOrderProcess" 
        />
    </div>
</template>
<script>
import ModalConditionShabu from '@/components/Modals/ModalConditionShabu'
import ModalOrderProcessShabu from '@/components/Modals/ModalOrderProcessShabu'
export default {
    name: "ModalInsurance" ,
    props: {
        shabuEVoucher: Object,
    },
    components:{
        ModalConditionShabu,
        ModalOrderProcessShabu
    },
    data() {
        return {
            shabuCondition:{
                show: false,
                status: false,
                confirm: false
            },
            shabuOrderProcess:{
                show: false,
                status: false,
            },
            switchModal: 'select',
            shabu: [
                {name: 'E-voucher ชาบูบู๊ตึ๊ง 500 บาท', qrCode: require('../../assets/images/shabu-bootueng.png'), link: 'https://forms.gle/4gd1N9DHZbWc7n6i7', rate:'469', code:'SBBT'},
            ],
            linkManual:"https://docs.google.com/presentation/d/1bFcXZBTDXBDTDj9WtsBTEnnsZ42Z_FwAqoKY8Wv-ieo/edit?usp=sharing",
        }
    },
    mounted() {

    },
    methods: {
        confirmConditionShabu(){
            this.shabuCondition.show = false
            this.shabuCondition.confirm = true
            this.shabuOrderProcess.show = true
        },
        confirmOrderProcess(){
            this.shabuOrderProcess.show = false
            this.shabuEVoucher.show = true
        },
        selectShabuEVoucher(){
            this.shabuCondition.status = false;
            this.shabuCondition.confirm = false;
            this.shabuCondition.show = true;
        }
    },
    computed: {
        
    }
}
</script>